export {
  default,
  default as ShareResourceHistoryModal,
} from "./ShareResourceHistoryModal";
